import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { ShareService } from '../service/share.service';
import { AdminshareService } from "../service/adminshare.service";
import { QuestionService } from '../service/question.service';
import { ActivatedRoute,Router  } from '@angular/router';
import { Location } from '@angular/common';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

@Component({
    selector: 'question-list-app',
    templateUrl: './question-list.component.html',
    styleUrls: ['question-list.component.css']
})
export class QuestionListComponent implements OnInit {
    @Input() event_id: number;
    title = 'Loading・・・';
    isLoaded : boolean = false;

    languagelist : any = [];
    datalist : any = [];
    datalist_target : any = [];
    target_pattern : any = [];

    disabled_flg:boolean = false;
    m_contract_company_id:number = null
    selected_question_category_id : number = null;
    selected_language_id : number = null;
    ROLE: any = Role;    
    constructor(
        private commonService: CommonService,
        private questionService: QuestionService,
        private adminShareService: AdminshareService,
        private shareService: ShareService,
        public usersService: UsersService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,

    ) { }

    ngOnInit(): void {
        this.selected_language_id = +this.route.snapshot.paramMap.get('lid');
        this.selected_question_category_id = +this.route.snapshot.paramMap.get('qcid');
        this.getList();
        //画面上部へ移動
        window.scrollTo(0, 0);

    };

    clearData (): void{
        this.title = '・・・';
        this.isLoaded = false;

        this.languagelist = [];
        this.datalist = [];
        this.datalist_target = [];
        this.target_pattern = [];
    }

    getList(): void {
        this.clearData();
        this.questionService.getQuestionList(this.selected_question_category_id,this.selected_language_id)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.languagelist = res["fuel_results"]["language"];
                //問診票が消された場合
                if (this.languagelist.length==0){
                    //消されたメッセージを表示し、問診票一覧画面へ飛ばす
                    this.commonService.modalOpens(11006,modalresult=>{
                        this.router.navigate(["/question-category/" + this.adminShareService.set_question_category.t_event_id]);
                    });
                }else{
                    if(this.languagelist[0]['closed']=="1" || this.languagelist[0]['used_flg']=="1"){
                        this.disabled_flg = true;

                    } else{
                        this.disabled_flg = false;
                    }
                }
                //問診票の言語が消された場合
                if (res["fuel_results"]["question_category"].length==0){
                    this.title = '対象の言語は削除されました';
                }else{
                    this.title = res["fuel_results"]["question_category"][0]['title_name'];
                }


                this.m_contract_company_id = res["fuel_results"]["m_contract_company_id"];
                this.datalist= res["fuel_results"]["question"];
                this.datalist_target= res["fuel_results"]["question_target"];
                this.target_pattern= res["fuel_results"]["question_matrix"];
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }

    checkMainLanguage():boolean{

        var row = this.languagelist.filter(
            item => 
            item.m_language_id==this.selected_language_id && item.main_language_flg == 1
          );  
        
          if (row.length > 0) {
            return true;
          } else {
            return false;
          }
    }

    onChange($event, deviceValue) {
        this.router.navigate(["/question-list/"+this.selected_question_category_id+"/"+this.selected_language_id]);
        this.getList();
    }

    addRow(result_option:number): void {
        this.router.navigate(["/question-register/" + this.selected_question_category_id + '/0/' + this.selected_language_id + '/' + result_option ]);
    }
    editRow(row:number,result_option:number) : void{
        this.router.navigate(["/question-register/" + this.selected_question_category_id + '/'+ row +'/' + this.selected_language_id + '/' + result_option ]);
    }
    copy(row:number):void{
        this.commonService.modalOpens(50004,
            //複写してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    let param={
                        qid: row,
                        qcid :this.selected_question_category_id,
                    };
                    this.questionService.copy(param)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10004, modalresult => {
                                    this.getList();
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                    } else {

                }
            }
        );

    }

    delRow(row:number,result_option:string) : void{
        let tempdatalist;
        if(result_option=="1"){
            tempdatalist = this.datalist_target;
        }else{
            tempdatalist = this.datalist;
        }

        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    this.questionService.delete(tempdatalist[row])
                    .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002,modalresult=>{
                                // tempdatalist.splice(row, 1); // i番目を１レコード削除
                                this.getList();
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                }else{
                    //
                }
            }
        );


    }
    
    upRow(row:number,result_option:string) : void{
        let tempdatalist;
        if(result_option=="1"){
            tempdatalist = this.datalist_target;
        }else{
            tempdatalist = this.datalist;
        }
        if (row==0){//最初

        }else{
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            //１つ前のレコード beforeRecord
            let beforeRecord = tempdatalist[row-1];

            //同じ質問の場合は何もしない
            if (myRecord['m_question_id']==beforeRecord['m_question_id']){
                return;
            }

            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            beforeRecord['chk_sort'] = beforeRecord['sort'];

            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = beforeRecord['sort'];
            beforeRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,beforeRecord
            this.questionService.changeOrder([myRecord,beforeRecord])
            .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        if(myRecord['previous_flg']==1 || beforeRecord['previous_flg']==1){
                            this.getList();
                        }else{
                            tempdatalist.splice(row-1, 2, tempdatalist[row], tempdatalist[row-1]);
                        }
                    }else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                    }else{
                        this.commonService.modalOpens(11003,modalresult=>{});
                    }
                },error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                });
            }
    }
    downRow(row:number,result_option:string) : void{
        let tempdatalist;
        if(result_option=="1"){
            tempdatalist = this.datalist_target;
        }else{
            tempdatalist = this.datalist;
        }
        if (row==tempdatalist.length -1){//最終

        }else{
            //１つ後ろのレコード afterRecord
            let afterRecord = tempdatalist[row+1];
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];

            //同じ質問の場合は何もしない
            if (myRecord['m_question_id']==afterRecord['m_question_id']){
                return;
            }
            
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            afterRecord['chk_sort'] = afterRecord['sort'];
            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = afterRecord['sort'];
            afterRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,afterRecord
            this.questionService.changeOrder([myRecord,afterRecord])
            .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        if(myRecord['previous_flg']==1 || afterRecord['previous_flg']==1){
                            this.getList();
                        }else{
                            tempdatalist.splice(row, 2, tempdatalist[row+1], tempdatalist[row]);
                        }
                    }else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                    }else{
                        this.commonService.modalOpens(11003,modalresult=>{});
                    }
                },error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                });
            
        }
    }

    preview() : void{
        //必要のないShareをリフレッシュしておく
        this.shareService.refleshAll();

        this.shareService.setCategoryInfoShare(
            {
                t_person_id:null,
                t_event_id:null,
                t_question_category_id:null,
                m_question_category_id:this.selected_question_category_id,
                m_language_id:this.selected_language_id
            }
        );
        let mode;
        if (this.disabled_flg){
            mode = 9;
        }else{
            mode = 3;
        }
        this.shareService.setModeShare(mode); 

        if(this.datalist_target.length > 0){
            this.router.navigate(["/answer-preview/start"]);
        }else{
            this.shareService.setStartResultListShare([]);
            this.router.navigate(["/answer-preview/main"]);
        }

        // var strURL = window.location.protocol+ "//" + window.location.host + "/" + 'public/#/answer/';
        // var strOptions = "width=600,height=800,resizable=yes,scrollbars=yes,status=no";
        // window.open(strURL,String(this.selected_question_category_id), strOptions);
    }

    goBack(): void {
        // this.location.back();
        this.router.navigate(["/question-category/" + this.adminShareService.set_question_category.event_id]);
    }
}


// WEBPACK FOOTER //
// ./src/app/a0104-question-list/question-list.component.ts